import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {
  TrustedCertificatesApiService
} from '../../../services/api/settings/administration/trusted-certificates/trusted-certificates-api.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {MatDialog} from '@angular/material/dialog';
import {TrustedCertificateDialogComponent} from './trusted-certificate-dialog/trusted-certificate-dialog.component';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {DisplayedColumnInf} from '../../../interfaces/common/table/displayed-column-inf';
import {AcDialogService} from 'ac-infra';
import {CertificateViewComponent} from '../../../components/certificates/certificate-view/certificate-view.component';

@Component({
  selector: 'trusted-certificates',
  templateUrl: './trusted-certificates.component.html',
  styleUrls: ['./trusted-certificates.component.scss']
})
export class TrustedCertificatesComponent implements OnInit {


  isUnauthorized: boolean;
  certificates: any = [];
  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'alias', display: 'Alias', selected: true,  width: 350}
  ];

  selection: any;

  constructor(private userPrivilege: UserPrivilegeService,
              private certificatesApiService: TrustedCertificatesApiService,
              private loaderService: LoaderService,
              private acDialogService: AcDialogService,
              public dialog: MatDialog,
              private snackBarService: SnackBarService) {}

  ngOnInit(): void {
    this.initialization();
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
  }

  initialization(): void {
    this.getAllCertificates();
  }

  getAllCertificates(): void {
    this.loaderService.showMainContainer();
    this.certificatesApiService.getCertificates().subscribe((certificates) => {
      this.certificates = certificates;
      this.selection = null;
      this.loaderService.hideMainContainer();
    });
  }

  addCertificate(): void {

    const dialogData = {
      certificateToAdd: {alias: '', value: ''},
      isEditMode: false,
    };

    this.acDialogService.open(TrustedCertificateDialogComponent, {
      width: 460,
      dialogData,
      onSubmit: () => {
        this.certificatesApiService.addCertificate(dialogData.certificateToAdd).subscribe((newCertificate) => {
          this.initialization();
          this.snackBarService.display(`"${newCertificate.alias}" successfully added`);
        });
      }
    });
  }

  deleteCertificate(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: `Are you sure you want to delete "${this.selection.alias}" ?`
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.certificatesApiService.removeCertificate(this.selection.alias).subscribe(() => {
        dialogRef.close();
        this.initialization();
        this.snackBarService.display(`${this.selection.alias} successfully deleted`);
      });
    });
  }

  onSelection(selection: any): void {
    this.selection = selection;

    this.selection.raw = this.selection.value;
    const dialogData = [this.selection];

    this.acDialogService.open(CertificateViewComponent, {
      title: 'Trusted Certificate',
      width: 550,
      dialogData,
      noSubmitButton: true
    });
  }
}
